module.exports = __webpack_public_path__ + "static/priscillayip-0c0e71c345724ee86b2f9ca076f96b85.png";